import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import theme from './theme';
import "./index.css";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { UserContextProvider } from './contexts/userContexts';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const queryClient = new QueryClient();

root.render(
  <ChakraProvider theme={theme}>
    <QueryClientProvider client={queryClient}>
      <UserContextProvider>
    <App />
      </UserContextProvider>
    </QueryClientProvider>
  </ChakraProvider>
);

serviceWorker.unregister();

reportWebVitals();
